module.exports = __webpack_public_path__ + "static/media/whatsapp_guide_mobile_04.b36492ff.png";